module.exports = __webpack_public_path__ + "img/farzana-christopher-26.2e9824bb.jpg";